var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNtaiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "abstract-22",
    clipPath: "url(#clip0_1_1660)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "abstract"
  }, /*#__PURE__*/React.createElement("path", {
    id: "abstract-22_2",
    d: "M12.1226 6.19008H7.72663V1.71708C7.70834 1.57939 7.64949 1.45025 7.55758 1.34611C7.46567 1.24196 7.34485 1.16751 7.2105 1.13223C7.07615 1.09696 6.93435 1.10245 6.80313 1.14801C6.67191 1.19357 6.55721 1.27714 6.47363 1.38808L2.72163 7.94708C2.66181 8.05351 2.63086 8.17374 2.63186 8.29583C2.63286 8.41791 2.66578 8.53761 2.72734 8.64305C2.7889 8.74848 2.87697 8.83598 2.9828 8.89686C3.08863 8.95774 3.20854 8.98987 3.33063 8.99008H7.72663V13.4631C7.74493 13.6008 7.80377 13.7299 7.89568 13.8341C7.98759 13.9382 8.10841 14.0127 8.24276 14.0479C8.37711 14.0832 8.51892 14.0777 8.65013 14.0322C8.78135 13.9866 8.89605 13.903 8.97963 13.7921L12.7316 7.23308C12.7915 7.12666 12.8224 7.00643 12.8214 6.88434C12.8204 6.76226 12.7875 6.64256 12.7259 6.53712C12.6644 6.43169 12.5763 6.34419 12.4705 6.28331C12.3646 6.22243 12.2447 6.19029 12.1226 6.19008Z",
    fill: "url(#paint0_linear_1_1660)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1660",
    x1: 5.49766,
    y1: -5.37152,
    x2: 15.1212,
    y2: -4.19791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#235539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B946B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.726562 0.590088)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNtaiLogo);
export default __webpack_public_path__ + "static/media/ntai_logo.80955f139c593e306201510cde9e6cf8.svg";
export { ForwardRef as ReactComponent };